import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { http } from '../../components/helper';
import FreeOfferProducts from '../checkout/FreeOfferproduct';


export const getProducts = createAsyncThunk(
  'products/getProducts',
  async (payload) => {
    const response = await http.post('products', payload);
    return response.data.data;
  }
);

export const getOfferProducts = createAsyncThunk(
  'products/getOfferProducts',
  async (payload) => {
    const response = await http.post('productsbyids', payload);
    return response.data.data;
  }
);

export const getFreeProducts = createAsyncThunk(
  'products/getFreeProducts',
  async (payload) => {
    const response = await http.post('freeproductsbyids', payload);
    return response.data.data;
  }
);

export const getFreeOfferProducts = createAsyncThunk(
  'products/getFreeOfferProducts',
  async (payload) => {
    const response = await http.post('freeproductsbyids', payload);
    return response.data.data;
  }
);

export const getSectorOfferProducts = createAsyncThunk(
  'products/getSectorOfferProducts',
  async (payload) => {
    const response = await http.post('freeproductsbyids', payload);
    return response.data.data;
  }
);

// fetch sectorwise product report
export const getSectorwiseProductReport = createAsyncThunk(
  'products/getSectorwiseProductReport',
  async (payload) => {
    const response = await http.post('admin/sectorwiseproductreport',payload);
    return response.data;  
  }
);

export const getProductBand = createAsyncThunk(
  'products/getProductBand',
  async (productCode) => {
    const response = await http.get(`/admin/productband/${productCode}`);
    return response.data;
  }
);
const initialState = {
  productList: [],
  offerProductList: [],
  freeProductList: [],
  FreeOfferProducts: [],
  SectorOfferProducts:[],
  sectorwiseProductReport: [],
  status: 'idle',
  sectorproductstatus:'idle',
  triggerFreeProductListPop: false,
  error: null,
  productBandData: null,
  productBandStatus: 'idle',
};


const productsSlice = createSlice({
  name: 'Products',
  initialState,
  reducers: {
    triggerFreeProductList(state, action) {
      state.triggerFreeProductListPop = action.payload;
    },
    resetProductList(state) {
      state.status = "idle";
      state.sectorproductstatus = "idle";
      state.productList = [];
      state.sectorwiseProductReport = [];
    },
    resetProductBand(state) {
      state.productBandData = null;
      state.productBandStatus = 'idle';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getProducts.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(getOfferProducts.fulfilled, (state, action) => {

        state.offerProductList = action.payload;
      })
      .addCase(getOfferProducts.rejected, (state) => {
        state.status = 'failed';
        state.offerProductList = [];
      })
      .addCase(getFreeProducts.fulfilled, (state, action) => {

        state.freeProductList = action.payload;
      })
      .addCase(getFreeProducts.rejected, (state) => {
        state.status = 'failed';
        state.freeProductList = [];
      })
      .addCase(getFreeOfferProducts.fulfilled, (state, action) => {
        state.FreeOfferProducts = action.payload;
      })
      .addCase(getFreeOfferProducts.rejected, (state) => {
        state.status = 'failed';
        state.FreeOfferProducts = [];
      }) 
      .addCase(getSectorOfferProducts.fulfilled, (state, action) => {
        state.SectorOfferProducts = action.payload;
      })
      .addCase(getSectorOfferProducts.rejected, (state) => {
        state.status = 'failed';
        state.SectorOfferProducts = [];
      })
      .addCase(getProducts.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.productList = action.payload;
      })
      .addCase(getProducts.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
      .addCase(getSectorwiseProductReport.pending, (state) => {
        state.sectorproductstatus = 'loading';
      })
      .addCase(getSectorwiseProductReport.fulfilled, (state, action) => {
        state.sectorproductstatus = 'succeeded';
        state.sectorwiseProductReport = action.payload;  
      })
      .addCase(getSectorwiseProductReport.rejected, (state, action) => {
        state.sectorproductstatus = 'failed';
        state.error = action.error.message;
      })
      .addCase(getProductBand.pending, (state) => {
        state.productBandStatus = 'loading';
      })
      .addCase(getProductBand.fulfilled, (state, action) => {
        state.productBandStatus = 'succeeded';
        state.productBandData = action.payload;
      })
      .addCase(getProductBand.rejected, (state) => {
        state.productBandStatus = 'failed';
        state.productBandData = null;
      })
  },
});

export const { triggerFreeProductList,resetProductList,resetProductBand } = productsSlice.actions;
export default productsSlice.reducer;